// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__WsSOD","leftControl":"Toggle_leftControl__Vq4Jn","rightControl":"Toggle_rightControl__PN5zX"};